import { HttpClient, provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, Injectable, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { MsalBroadcastService, MsalGuard, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication } from '@azure/msal-browser';
import { provideTransloco, TranslocoLoader } from '@jsverse/transloco';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { msalGuardConfigFactory, msalInstanceFactory } from './core/auth/auth.config';
import { AuthService } from './core/auth/auth.service';
import { routes } from './app.routes';

@Injectable()
class TranslationLoader implements TranslocoLoader {
  constructor(private readonly http: HttpClient) {}
  getTranslation(lang: string): Observable<Record<string, string>> { return this.http.get<Record<string, string>>(`/assets/i18n/${lang}.json`); }
}
function initializeMsal(instance: IPublicClientApplication, auth: AuthService): () => Promise<void> {
  return async () => { await instance.initialize(); const result = await instance.handleRedirectPromise(); if (result?.account) instance.setActiveAccount(result.account); auth.initializeAccount(); };
}
export const appConfig: ApplicationConfig = { providers: [
  provideBrowserGlobalErrorListeners(), provideRouter(routes, withComponentInputBinding()), provideHttpClient(),
  provideServiceWorker('ngsw-worker.js', { enabled: environment.production, registrationStrategy: 'registerWhenStable:30000' }),
  { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory }, { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
  MsalService, MsalGuard, MsalBroadcastService,
  { provide: APP_INITIALIZER, multi: true, useFactory: initializeMsal, deps: [MSAL_INSTANCE, AuthService] },
  provideTransloco({ config: { availableLangs: ['pt', 'en', 'es', 'de'], defaultLang: 'pt', reRenderOnLangChange: true, prodMode: environment.production }, loader: TranslationLoader }),
  provideMarkdown({ markedOptions: { provide: MARKED_OPTIONS, useValue: { gfm: true, breaks: true, pedantic: false } } }),
] };
